import { Button, Icon } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { DownloadReport } from '@hero/components/modals';
import { ThankYouNotesDetailTable } from '@hero/organisms';
import { useThankYouMessagesReport } from '@hero/services/analytic-service/hooks';

import * as SS from '../style';

const ThankYouNotesDetail = () => {
  const { t } = useTranslation();
  const { recognitionCode } = useParams();

  const [isOpenDownloadReport, setIsOpenDownloadReport] = useState(false);

  const openDownloadReportHandler = () => {
    setIsOpenDownloadReport(true);
  };
  const closeDownloadReportHandler = () => {
    setIsOpenDownloadReport(false);
  };

  const { mutateAsync: generateTYMessagesReport } = useThankYouMessagesReport();

  return (
    <>
      <SS.HeaderWrapper>
        <Button
          variant="text"
          onClick={openDownloadReportHandler}
          startIcon={<Icon name="download" />}
        >
          {t('downloadReport')}
        </Button>
      </SS.HeaderWrapper>
      <ThankYouNotesDetailTable />
      <DownloadReport
        isOpen={isOpenDownloadReport}
        onRequestClose={closeDownloadReportHandler}
        onAsyncSubmit={async data => {
          await generateTYMessagesReport({
            organizationCode: data?.organization?.code,
            emails: data.contacts.map(item => item.email),
            filters: {
              associationType: 'recognition',
              associationCode: recognitionCode
            }
          });
        }}
      />
    </>
  );
};

export default ThankYouNotesDetail;
